(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6575],{

/***/ 6575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SocialLinks": function() { return /* binding */ SocialLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8193);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63750);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89583);
/* harmony import */ var react_icons_gr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45155);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(636);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);









var SocialLinks = function SocialLinks() {
  var _facebbokSocila$defau, _instratSocila$defaul;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      defaultCountryCode = _useState[0],
      setDefaultCountryCode = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTimeout(function () {
      if (typeof js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z == "object") {
        if (js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("default_country")) {
          setDefaultCountryCode(js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("default_country"));
        }
      }
    }, 1500);
  }, [defaultCountryCode]);
  var facebbokSocila = {
    // in: "https://www.facebook.com/UniSearchBangladesh",
    my: "https://www.facebook.com/UniSearchMalaysia"
  };
  var instratSocila = {
    "in": "https://www.instagram.com/unisearchindia",
    my: "https://www.instagram.com/myunisearch"
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("ul", {
    className: (_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default().social_links),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: "https://twitter.com/myunisearch",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaTwitter */ .fWC, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: "https://www.linkedin.com/company/my-unisearch",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaLinkedinIn */ .BUd, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: (_facebbokSocila$defau = facebbokSocila[defaultCountryCode]) !== null && _facebbokSocila$defau !== void 0 ? _facebbokSocila$defau : "https://www.facebook.com/UniSearchBangladesh",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_gr__WEBPACK_IMPORTED_MODULE_5__/* .GrFacebookOption */ .f1b, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: "https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaYoutube */ .V2E, {})
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: (_instratSocila$defaul = instratSocila[defaultCountryCode]) !== null && _instratSocila$defaul !== void 0 ? _instratSocila$defaul : "https://www.instagram.com/unisearchindia",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_6__/* .AiFillInstagram */ .t0C, {
          style: {
            fontSize: "18px"
          }
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        rel: "nofollow",
        target: "_blank",
        href: "https://www.pinterest.com/myunisearch",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_7__/* .BsPinterest */ .I30, {
          style: {
            fontSize: "16px"
          }
        })
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (SocialLinks);

/***/ }),

/***/ 636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social_links":"social_links_social_links__QaCZo"};

/***/ })

}]);